<script>
    import { getContext } from 'svelte';
    import Number from './util/Number.svelte';

    export let dataKey;

    const { corr_highpass, matches_highpass } = getContext(dataKey);
</script>

<div class="col card">
    <h3>Transactions in Kronos</h3>
    <p>
        Which creditcard and loyalty cards belong together? A <i>match</i>
        is a transactions that occured on the same day, at the same location, for
        the same ammount of money. The matches are ranked by the ratio between the
        number of matched transactions and the total number of transactions. The
        same ratio is computed for price.
    </p>
    <span>
        Correlation threshold <Number
            min="0"
            max="1"
            step="0.05"
            bind:value={$corr_highpass}
        />
    </span>
    <span>
        Minimum number of exact matches <Number
            min=0
            max=100
            step=1
            bind:value={$matches_highpass}
        />
    </span>
</div>
